<div class="king-top">
  @if (kingService.game()?.gameid) {
  <app-fairness-button
    class="king-fairness"
    href="/provably-fair/king/{{ kingService.game()?.gameid }}"
  ></app-fairness-button>
  }
  <app-king-timer class="king-timer"></app-king-timer>
  <app-king-queue class="king-queue"></app-king-queue>
  <button
    class="king-create button button--style-yellow padding-x-12 h-36"
    (click)="openDepositModal()"
  >
    <app-game-icon icon [game]="'King'" color="black"></app-game-icon>
    Join Game
  </button>
</div>

<div class="king__area">
  <app-king-side-top
    class="king__king"
    [user]="kingService.game()?.king ?? null"
  ></app-king-side-top>
  <svg
    class="king-swords"
    [class.king-hit]="kingService.game()?.part && hit() && kingHit()"
    [class.challenger-hit]="kingService.game()?.part && hit() && !kingHit()"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.5397 14.4605L19.9424 12.7208L19.308 12.0294L17.7037 10.2818L25.0465 2.28264C25.7752 1.48826 26.7395 0.947595 27.7975 0.739818L31.5304 0.00734087C31.659 -0.0178263 31.7915 0.0225857 31.8847 0.115238C31.9773 0.20835 32.0178 0.340757 31.9926 0.469484L31.2601 4.20244C31.0523 5.26045 30.5117 6.22462 29.7174 6.95342L21.5397 14.4605Z"
      fill="#414141"
    />
    <path
      d="M10.6118 18.0074L7.2123 21.7116C6.07222 20.9228 4.77942 20.3361 3.36776 20.0438C2.68805 19.9015 2.02483 20.3386 1.88448 21.0184C1.74346 21.6969 2.17984 22.3614 2.85896 22.5017C3.89739 22.7169 4.84934 23.1448 5.69582 23.7141L1.00428 27.3558C0.415842 27.8125 0.0523309 28.4997 0.00508499 29.243C-0.0415039 29.986 0.233758 30.7135 0.760298 31.2402C1.24813 31.7286 1.90892 32.0002 2.59487 32.0002C2.64882 32.0002 2.7027 31.999 2.75738 31.9953C3.50083 31.9488 4.18796 31.5853 4.64459 30.9968L8.20466 26.4107C8.60681 27.1224 8.91078 27.8972 9.08249 28.7252C9.20504 29.3186 9.72717 29.7262 10.3102 29.7262C10.3948 29.7262 10.4799 29.7176 10.5658 29.6998C11.245 29.5594 11.6814 28.895 11.5405 28.2165C11.2904 27.007 10.8152 25.8902 10.195 24.8746L14.1437 21.2495L10.6118 18.0074Z"
      fill="#414141"
    />
    <path
      d="M30.9955 27.3559L27.3858 24.554L26.3039 23.7142C27.102 23.1773 28.4221 22.7062 29.1409 22.5018C29.86 22.2972 30.2564 21.697 30.1155 21.0185C29.9745 20.3387 29.3057 19.9005 28.6321 20.0439C28.0974 20.1548 27.5802 20.3087 27.08 20.4957C26.258 20.8027 25.4962 21.2213 24.7875 21.7117L6.95339 2.28266C6.22452 1.48828 5.26029 0.947679 4.20248 0.739836L0.469388 0.00735959C0.444352 0.00249701 0.41925 0 0.394083 0C0.290523 0 0.18992 0.0410692 0.115142 0.115256C0.0226209 0.208369 -0.0177911 0.340841 0.00731035 0.469568L0.739787 4.20246C0.947564 5.26047 1.4883 6.22464 2.28261 6.95344L21.8047 24.8746C21.3476 25.6231 20.9852 26.4309 20.7235 27.2897C20.6303 27.5962 20.5249 27.8984 20.4594 28.2166C20.3184 28.8951 20.7548 29.5595 21.4339 29.6999C21.5198 29.7177 21.605 29.7263 21.6895 29.7263C22.1211 29.7263 22.5171 29.5013 22.7445 29.1445C22.8242 29.0195 22.8855 28.8798 22.9173 28.7253C23.089 27.8973 23.393 27.1225 23.7951 26.4108L24.5527 27.3866L27.3551 30.9969C27.8118 31.5855 28.499 31.9489 29.2424 31.9954C29.9853 32.042 30.713 31.7674 31.2396 31.2403C31.7661 30.7136 32.0412 29.9861 31.9947 29.2431C31.9475 28.4998 31.5841 27.8126 30.9955 27.3559Z"
      fill="#414141"
    />
  </svg>
  <app-king-side-top
    class="king__challenger"
    [user]="kingService.game()?.part ?? null"
    [isChallenger]="true"
  ></app-king-side-top>
</div>

<button
  class="king-create__mobile button button--style-yellow padding-x-12 h-36"
  (click)="openDepositModal()"
>
  <app-game-icon icon [game]="'King'" color="black"></app-game-icon>
  Join Game
</button>
<div class="king-skins">
  <app-king-side-bottom
    [user]="kingService.game()?.king ?? null"
  ></app-king-side-bottom>
  <app-king-side-bottom
    [user]="kingService.game()?.part ?? null"
    [isChallenger]="true"
  ></app-king-side-bottom>
</div>
<div class="king-hash" [style.opacity]="kingService.game()?.hash ? 100 : 0">
  Hash: {{ kingService.game()?.hash }} | Game ID:
  {{ kingService.game()?.gameid }} | Round ID: {{ kingService.game()?.round }}
</div>
<div class="king-history" [@listAnimation]="kingService.history().length">
  @for (game of kingService.history(); track $index) {
  <app-king-row [game]="game"> </app-king-row>
  }
</div>
